export const exportFunction = {
  methods: {
    export: function (tableHeader, tableBody, filename) {
      let csvHeader = "";
      let csvRows = "";
      let finalCsv = "";
      const proccessHeader = data => {
        let headerRow = "";
        data.forEach(item => {
          headerRow += `${item},`;
        });

        headerRow += "\n";

        return headerRow;
      };

      csvHeader = proccessHeader(tableHeader);

      const processRow = data => {
        let rows = "";
        rows += `${data.join(",") + "\n"}`;
        return rows;
      };

      csvRows = processRow(tableBody);

      finalCsv = csvHeader + csvRows;

      var blob = new Blob([finalCsv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", filename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
  },
};
